import { queryOptions } from "@tanstack/react-query";

import { OffsetPageParams } from "@safetyculture/s12-apis-connect-web/s12/common/v1/page_offset_pb";
import { SensorType } from "@safetyculture/s12-apis-connect-web/s12/sensors/admin/v1/sensors_pb";

import { listArchivedSensorsForOrg } from "../api/endpoints/sensors";
import { callOptionsHeaders } from "../api/helpers";

type ArchivedSensorsOptionsParams = {
  regionCode: string;
  roleId: string;
  page: number;
  pageSize: number;
  query: string;
  sensorType: SensorType;
};

export function archivedSensorsOptions({
  regionCode,
  roleId,
  page,
  pageSize,
  query,
  sensorType,
}: ArchivedSensorsOptionsParams) {
  return queryOptions({
    queryKey: [
      "archivedSensors",
      regionCode,
      roleId,
      page,
      pageSize,
      query,
      sensorType,
    ],
    queryFn: () =>
      listArchivedSensorsForOrg(
        {
          orgId: roleId,
          page: new OffsetPageParams({ offset: page * pageSize, pageSize }),
          query,
          sensorType,
        },
        callOptionsHeaders(regionCode, roleId),
      ),
    staleTime: 60 * 1000,
  });
}
